export const List = () => import("./List.vue");
export const InOut = () => import("./InOut.vue");
export const Incoming = () => import("./Incoming.vue");
export const Outgoing = () => import("./Outgoing.vue");
export const Dashboard = () => import("./Dashboard.vue");
export const inVisitors = () => import("./InVisitors.vue");
export const Completed = () => import("./CompletedVisitors.vue");
export const DailyIncident = () => import("./DailyIncident.vue");
export const VisitorStatus = () => import("./VisitorStatus.vue");
export const VisitorDetails = () => import("./VisitorDetails.vue");
export const VisitorLRCSummary = () => import("./VisitorLRCSummary.vue");
export const VisitorPCardDetails = () => import("./VisitorPCardDetails.vue");
export const VisitorVCardDetails = () => import("./VisitorVCardDetails.vue");
export const VisitorVCardActivity = () => import("./VisitorVCardActivity.vue");
export const VisitorStatusDetails = () => import("./VisitorStatusDetails.vue");
export const VisitorLRCUnitDetails = () => import("./VisitorLRCUnitDetails.vue");
export const VisitorLRCStatusDetails = () => import("./VisitorLRCStatusDetails.vue");
